export enum EnumProductType {
  ATOMIC = 'ATOMIC',
  KIT = 'KIT',
  PACK = 'PACK'
}
